import {t} from "@lingui/core/macro";
import * as React from "react";

import Link from "@khanacademy/wonder-blocks-link";
import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";
import type {ClassRouteName} from "@khan/class-types";

interface Props {
    href: string;
    routeName?: ClassRouteName;
}

/**
 * The help link for the side nav. Used internally. To add a help link to your
 * side nav bar, use the `helpUrl` prop on `SideNavPageLayout` instead!
 */
function SideNavHelpLink({href, routeName}: Props): React.ReactElement {
    const publishAnalyticsEvent = usePublishAnalyticsEvent();
    const handleClick = React.useCallback(() => {
        if (routeName) {
            publishAnalyticsEvent({
                eventType: "ClassDashHelpOpened",
                eventSchemaVersion: 2,
                currentScreenName: routeName,
            });
        }
    }, [publishAnalyticsEvent, routeName]);

    return (
        <Link
            testId="class-dashboard-side-nav-help"
            href={href}
            target="_blank"
            onClick={handleClick}
        >
            {t`Help with this page`}
        </Link>
    );
}

export default SideNavHelpLink;
